import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("UserUpdateInput")
export class UserUpdateInput {
    @JsonProperty()
    public name: string = JsonPropertyEmpty;

    @JsonProperty()
    public email: string = JsonPropertyEmpty;

    @JsonProperty()
    public role: string = JsonPropertyEmpty;

    @JsonProperty()
    public enabled: boolean = JsonPropertyEmpty;

    public constructor(args?: Partial<UserUpdateInput>) {
        Object.assign(this, args);
    }
}
